import { Component, signal } from '@angular/core'
import { takeUntilDestroyed } from '@angular/core/rxjs-interop'
import { AppStateService } from 'src/app/core/services/app-state.service'
import { format } from 'date-fns'
import { getTimeZoneLabel } from 'src/app/shared/utils/date.utils'

@Component({
  selector: 'app-rollout-date',
  templateUrl: './rollout-date.component.html',
  styleUrls: ['./rollout-date.component.scss'],
  standalone: false,
})
export class RolloutDateComponent {
  public rolloutDate = signal('')

  constructor(private appState: AppStateService) {
    this.appState.stateChanged.pipe(takeUntilDestroyed()).subscribe((state) => {
    this.rolloutDate.set(this.formatToLocalTime(state.rolloutDate))
    })

    this.rolloutDate.set(this.formatToLocalTime(this.appState.getState().rolloutDate))
  }

  private formatToLocalTime(timestamp?: string | null): string {
    if (!timestamp) {
      return ''
    }

    const date = new Date(timestamp)
    if (isNaN(date.getTime())) {
      return timestamp
    }

    return `${format(date, 'yyyy-MM-dd HH:mm')} (${getTimeZoneLabel(date)})`
  }
}
